






import { Component, mixins } from "nuxt-property-decorator";
import BaseLayoutMixin from "../BaseLayoutMixin";
import PageBreadcrumbs from "../PageBreadcrumbs.vue";

@Component({
  components: { PageBreadcrumbs },
})
export default class WideLayout extends mixins(BaseLayoutMixin) {}
